<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div
      v-if="getWebProductEnableTemplateChooser"
      :class="getClassName + 'TemplateContainer'"
    >
      <SelectOption v-model="value" :options="options" :settings="settings" />
    </div>
    <button
      :disabled="!getMatrixComplete"
      ref="personalizeBtn"
      type="button"
      class="btn btn-primary"
      :class="getDisableClass"
      @click="onClickPersonalize()"
    >
      {{ name }}
    </button>
    <appAwesomeIcon
      v-if="showChecked"
      icon="check"
      class="matrix_personalizationButtonChecked"
    ></appAwesomeIcon>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useCustomerStore } from "@/stores/modules/customer";
import { useQuantityFieldStore } from "@/stores/modules/quantityField";
import { useBundleStore } from "@/stores/modules/bundle";

import * as R from "ramda";

import { i18n } from "../../i18n.js";
import { extendWith } from "lodash";

export default {
  computed: {
    ...mapState(useConfigStore, ["getMatrixComplete"]),
    ...mapState(usePersonalizeStore, [
      "getPersonalizeLoading",
      "getPPWithCustomizedProductId"
    ]),
    ...mapState(useWebproductStore, [
      "getWebProductTemplate",
      "getIsPersonalizationNewPage",
      "getWebProductEnableTemplateChooser",
      "getWebProductEnableTemplates",
      "getSelectedTemplateId",
      "getHideSearchBoxInPoptext",
      "getTheme",
      "getSweetAlert"
    ]),
    ...mapState(useChangeOptionsStore, [
      "getQuantity",
      "getChangeOptionsData",
      "getChangeOptionsBundleTemplate"
    ]),
    ...mapState(useCustomerStore, ["getCustomer", "getIsLogin"]),
    ...mapState(useQuantityFieldStore, ["getQuantityField"]),
    ...mapState(useBundleStore, [
      "getBundleTemplatePP",
      "getBundleIsActive",
      "getBundlePdfVtFile",
      "getBundleIsPdfVt",
      "getBundleIsPdfVtComplete"
    ]),
    name: function () {
      if (this.propsData && this.propsData.label) {
        return i18n.t("Personalize") + " " + this.propsData.label;
      }
      return i18n.t("Personalize");
    },
    showChecked: function () {
      if (this.propsData && this.propsData.code) {
        return this.getPPWithCustomizedProductId.includes(this.propsData.code);
      }
      return false;
    },
    settings: function () {
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { ...hideOptions };
    },
    getDisableClass: function () {
      return this.getPersonalizeLoading ? "disable" : "";
    },
    options: function () {
      return this.getWebProductEnableTemplates;
    },
    value: {
      get: function () {
        return this.getSelectedTemplateId;
      },
      set: function (newValue) {
        this.setSelectedTemplateId(newValue);
      }
    }
  },
  methods: {
    ...mapActions(usePersonalizeStore, ["getPersonalizeUrl"]),
    ...mapActions(useWebproductStore, [
      "setSelectedTemplateId",
      "openFancybox"
    ]),
    onClickPersonalize: function () {
      if (
        this.getBundleIsActive &&
        this.getBundleIsPdfVt &&
        !this.getBundleIsPdfVtComplete
      ) {
        this.getSweetAlert({
          text: i18n.t("Please update the data file first !"),
          icon: "warning"
        });
        return;
      }
      const formEl = jQuery(this.$refs.personalizeBtn).closest("form");
      const formParams = formEl.serializeArray();

      const params = R.reduce(
        (acc, param) => {
          if (
            [
              "customizedProductId",
              "customizedProductIdSaveFrame",
              "templateId",
              "pq_type"
            ].indexOf(param.name) !== -1
          ) {
            return acc;
          }
          acc[param.name] = param.value;
          return acc;
        },
        {},
        formParams
      );

      const isPersonalizationNewPage = this.getIsPersonalizationNewPage;

      params.template_id = this.getWebProductTemplate;
      params.isPersonalizationNewPage = isPersonalizationNewPage;
      params.personalizationQty = this.getQuantity;
      params.qty = this.getQuantity;
      params.customer = this.getCustomer;
      params.isLogin = this.getIsLogin;
      if (this.getTheme) {
        params.theme = this.getTheme;
      }
      if (this.getBundleIsActive && this.getBundlePdfVtFile) {
        params["selection_for_pdfvt"] = this.getBundlePdfVtFile;
      }
      if (this.propsData && this.propsData.code) {
        params.product_part = this.propsData.code;
        if (this.getBundleIsActive) {
          const bundle_template_mapping = this.getChangeOptionsBundleTemplate;
          if (
            bundle_template_mapping &&
            typeof bundle_template_mapping[this.propsData.code] !== "undefined"
          ) {
            params.template_id = Object.keys(
              bundle_template_mapping[this.propsData.code]
            )[0];
          } else {
            const bundle_template = this.getBundleTemplatePP(
              this.propsData.code
            );
            if (bundle_template) {
              params.template_id = bundle_template;
            }
          }
        }
      }

      this.getPersonalizeUrl({
        wnd: this,
        params: params,
        personalizationCB: url => {
          if (isPersonalizationNewPage) {
            window.location.href = url;
          } else {
            this.openFancybox({ src: url });
          }
        }
      });
    }
  },
  props: ["propsData", "alwaysShow"]
};
</script>
